module.exports = "/static/assets/0d34c80e3919306cb722380e920cffac.png";